module.exports = __webpack_public_path__ + "static/media/anniu3_hui.40691ebe.png";